<template>
  <v-container fluid grid-list-md>
    <v-layout wrap :column="$vuetify.breakpoint.xsOnly">
      <v-flex xs3>
        <DashboardCardListLink
          title="Acesso Rápido"
          itemIcon="icon"
          :items="acessoRapidoLinks"
          :showActionIcon="false"
          :showCounter="false"
          textStyle="title text-uppercase"
        />
      </v-flex>
      <v-flex xs3>
        <DashboardCardListLink
          title="Minhas Execuções"
          :items="minhasExecucoes"
          itemRoute="altera atividade"
          itemKey="IdAtividade"
          :itemAction="true"
          :itemActions="['Parar']"
          :loading="loadingMinhasExecucoes"
          @refreshCard="getMinhasExecucoes"
          @Parar="paraExecucaoAtividade"
        />
      </v-flex>
      <v-flex xs6>
        <DashboardCardListLink
          title="Minhas Atividades de Hoje"
          :items="atividadesHoje"
          itemRoute="altera atividade"
          itemKey="IdAtividade"
          itemAvatar="Clientes"
          :itemAction="true"
          :itemActions="['Iniciar']"
          :loading="loadingAtividadesHoje"
          @refreshCard="getTodayAtividades"
          @Iniciar="iniciaExecucaoAtividade"
        />
      </v-flex>
    </v-layout>
    <v-layout wrap :column="$vuetify.breakpoint.xsOnly">
      <v-flex xs3>
        <DashboardCardList
          title="Colaboradores em Execução"
          :items="colaboradoresExecucao"
          itemText="Colaborador"
          :loading="loadingColaboradoresExecucao"
          @refreshCard="getColaboradoresExecucao"
        />
      </v-flex>
      <v-flex xs9>
        <DashboardCardListLink
          title="Atividades em Execução"
          :items="atividadesExecucao"
          itemRoute="altera atividade"
          itemKey="IdAtividade"
          itemAvatar="Colaboradores"
          :loading="loadingAtividadesExecucao"
          @refreshCard="getAtividadesExecucao"
        />
      </v-flex>
    </v-layout>
    <v-layout wrap :column="$vuetify.breakpoint.xsOnly">
      <v-flex xs3>
        <DashboardCardListLink
          title="Meus Projetos"
          :items="meusProjetos"
          itemRoute="altera projeto"
          itemText="Projeto"
          itemKey="IdProjeto"
          itemAvatar="Fantasia"
          :loading="loadingMeusProjetos"
          @refreshCard="getProjetosAtivos"
        />
      </v-flex>
      <v-flex xs9>
        <DashboardCardListGroup
          title="Minhas Atividades Atrasadas"
          :items="atividadesAtrasadas"
          itemText="TipoAtividade"
          itemKey="IdTipoAtividade"
          itemAvatar="Clientes"
          itemRoute="altera atividade"
          :loading="loadingAtividadesAtrasadas"
          @refreshCard="getAtividadesAtrasadas"
          @getAtividadesByType="getAtividadesByType"
          :itemChildHeaders="['IdAtividade', 'Descricao', 'DataPrevisao']"
          :key="keyAtividadesAtrasadas"
        />
      </v-flex>
    </v-layout>
    <v-layout wrap :column="$vuetify.breakpoint.xsOnly">
      <v-flex xs12>
        <DashboardCardListGroup
          title="Minhas Atividades Futuras"
          :items="atividadesFuturas"
          itemText="TipoAtividade"
          itemKey="IdTipoAtividade"
          itemAvatar="Clientes"
          itemRoute="altera atividade"
          :loading="loadingAtividadesFuturas"
          @refreshCard="getAtividadesFuturas"
          @getAtividadesByType="getAtividadesFuturasByType"
          :itemChildHeaders="['IdAtividade', 'Descricao', 'DataPrevisao']"
          :key="keyAtividadesFuturas"
        />
      </v-flex>
    </v-layout>
    <v-speed-dial
      class="mb-4"
      v-model="fab"
      fixed
      bottom
      right
      direction="top"
      transition="slide-y-reverse-transition"
    >
      <template v-slot:activator>
        <v-btn
          v-model="fab"
          color="primary"
          dark
          fab
        >
          <v-icon>add</v-icon>
          <v-icon>close</v-icon>
        </v-btn>
      </template>
      <v-tooltip left>
        <ModalCadastroProjeto icon="assignment" color="success" slot="activator" />
        <span>Criar Projeto</span>
      </v-tooltip>
      <v-tooltip left>
        <ModalCadastro icon="assignment" color="info" :cliente="null" slot="activator" />
        <span>Criar Atividade</span>
      </v-tooltip>
    </v-speed-dial>
  </v-container>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { changePageTitle } from '../utils/changePageTitle';
import { dashboardService } from '@/domain/dashboard/DashboardService';
import { atividadeService } from '@/domain/atividade/AtividadeService';
import { projetoService } from '@/domain/projeto/ProjetoService';
import DashboardCardList from '@/components/dashboard/DashboardCardList';
import DashboardCardListLink from '@/components/dashboard/DashboardCardListLink';
import DashboardCardListGroup from '@/components/dashboard/DashboardCardListGroup';
import ModalCadastro from '@/components/atividade/ModalCadastro';
import ModalCadastroProjeto from '@/components/projeto/ModalCadastroProjeto';

export default {
  name: 'Home',
  components: {
    DashboardCardList,
    DashboardCardListLink,
    DashboardCardListGroup,
    ModalCadastro,
    ModalCadastroProjeto
  },
  data: () => ({
    fab: false,
    // tabs: null,
    keyAtividadesAtrasadas: 0,
    keyAtividadesFuturas: 0,
    acessoRapidoLinks: [
      { Descricao: 'Helpdesk', route: 'helpdesk', icon: 'dashboard' },
      { Descricao: 'Projetos', route: 'projetos', icon: 'assignment' },
      { Descricao: 'Atividades', route: 'atividades', icon: 'assignment' },
      { Descricao: 'Ocorrências', route: 'atividadesocorrencias', icon: 'chat' },
      { Descricao: 'Notificações', route: 'notificacoes', icon: 'notifications' },
      { Descricao: 'Clientes', route: 'clientes', icon: 'group' },
    ],
    minhasExecucoes: [],
    colaboradoresExecucao: [],
    atividadesExecucao: [],
    atividadesHoje: [],
    atividadesAtrasadas: [],
    atividadesFuturas: [],
    meusProjetos: [],
    loadingMinhasExecucoes: false,
    loadingColaboradoresExecucao: false,
    loadingAtividadesExecucao: false,
    loadingAtividadesHoje: false,
    loadingAtividadesAtrasadas: false,
    loadingAtividadesFuturas: false,
    loadingMeusProjetos: false,
  }),
  computed: {
    ...mapGetters(['user']),
    // activeFab () {
    //   switch (this.tabs) {
    //     case 'one': return { 'class': 'purple', icon: 'account_circle' }
    //     case 'two': return { 'class': 'red', icon: 'edit' }
    //     case 'three': return { 'class': 'green', icon: 'keyboard_arrow_up' }
    //     default: return {}
    //   }
    // }
  },
  methods: {
    ...mapMutations(['showNotification', 'closeNotification']),
    async iniciaExecucaoAtividade(payload) {
      if (confirm('Tem certeza que deseja iniciar a execução dessa atividade?')) {
        try {
          await atividadeService.iniciarAtividade(payload.IdAtividade);
          this.getAtividadesExecucao();
          this.getMinhasExecucoes();
          this.showNotification({ text: 'Atividade iniciada com sucesso.', status: 'success' });
        } catch (error) {
          const text = error.response.data.error;
          this.showNotification({ text, status: 'error' });
        }
      } else {
        this.showNotification({ text: 'Operação cancelada.', status: 'error' });
      }
    },
    async paraExecucaoAtividade(payload) {
      if (confirm('Deseja parar a execução dessa atividade?')) {
        try {
          await atividadeService.pausarAtividade(payload.IdAtividade);
          this.getAtividadesExecucao();
          this.getMinhasExecucoes();
          this.showNotification({ text: 'Operação realizada com sucesso', status: 'success' });
        } catch (error) {
          const text = error.response.data.error;
          this.showNotification({ text, status: 'error' });
        }
      } else {
        this.showNotification({ text: 'Operação cancelada', status: 'error' });
      }
    },
    async getMinhasExecucoes() {
      this.loadingMinhasExecucoes = true;
      const IdResponsavel = this.user.IdColaborador;
      const response = await dashboardService.getResultDashboard('MinhasExecucoes', IdResponsavel);
      this.minhasExecucoes = response && response.data ? response.data : [];
      this.loadingMinhasExecucoes = false;
    },
    async getColaboradoresExecucao() {
      this.loadingColaboradoresExecucao = true;
      const response = await dashboardService.getResultDashboard('ColaboradoresExecucao');
      this.colaboradoresExecucao = response && response.data ? response.data : [];
      this.loadingColaboradoresExecucao = false;
    },
    async getAtividadesExecucao() {
      this.loadingAtividadesExecucao = true;
      const response = await dashboardService.getResultDashboard('AtividadesExecucao');
      this.atividadesExecucao = response && response.data ? response.data : [];
      this.loadingAtividadesExecucao = false;
    },
    async getTodayAtividades() {
      this.loadingAtividadesHoje = true;
      const response = await atividadeService.getTodayAtividades();
      this.atividadesHoje = response && response.data ? response.data : [];
      this.loadingAtividadesHoje = false;
    },
    async getAtividadesAtrasadas() {
      const IdResponsavel = this.user.IdColaborador;
      this.loadingAtividadesAtrasadas = true;
      const response = await dashboardService.getResultDashboard('AtividadesAtrasadas', IdResponsavel);
      this.atividadesAtrasadas = response && response.data ? response.data : [];
      this.keyAtividadesAtrasadas++;
      this.loadingAtividadesAtrasadas = false;
    },
    async getAtividadesByType(type) {
      this.loadingAtividadesAtrasadas = true;
      const response = await atividadeService.getAtividadesPendentesByType(type);
      const atividades = response && response.data ? response.data : [];
      // Atribui as atividades ao objeto do tipo atividade
      const updObject = this.atividadesAtrasadas.find(obj => obj.IdTipoAtividade == type);
      updObject.Items = atividades;
      // Realiza uma mutação na posição do objeto do tipo atividade
      const index = this.atividadesAtrasadas.findIndex(obj => obj.IdTipoAtividade === type);
      if (index !== -1) {
        this.atividadesAtrasadas.splice(index, 1, updObject);
      }
      this.loadingAtividadesAtrasadas = false;
    },
    async getAtividadesFuturas() {
      const IdResponsavel = this.user.IdColaborador;
      this.loadingAtividadesFuturas = true;
      const response = await dashboardService.getResultDashboard('AtividadesFuturas', IdResponsavel);
      this.atividadesFuturas = response && response.data ? response.data : [];
      this.keyAtividadesFuturas++;
      this.loadingAtividadesFuturas = false;
    },
    async getAtividadesFuturasByType(type) {
      this.loadingAtividadesFuturas = true;
      const response = await atividadeService.getAtividadesFuturasByType(type);
      const atividades = response && response.data ? response.data : [];
      // Atribui as atividades ao objeto do tipo atividade
      const updObject = this.atividadesFuturas.find(obj => obj.IdTipoAtividade == type);
      updObject.Items = atividades;
      // Realiza uma mutação na posição do objeto do tipo atividade
      const index = this.atividadesFuturas.findIndex(obj => obj.IdTipoAtividade === type);
      if (index !== -1) {
        this.atividadesFuturas.splice(index, 1, updObject);
      }
      this.loadingAtividadesFuturas = false;
    },
    // Projetos
    async getProjetosAtivos() {
      this.loadingMeusProjetos = true;
      const response = await projetoService.getProjetosAtivos();
      this.meusProjetos = response && response.data ? response.data : [];
      this.loadingMeusProjetos = false;
    },
  },
  created() {
    changePageTitle('Dashboard');
    this.getMinhasExecucoes();
    this.getColaboradoresExecucao();
    this.getAtividadesExecucao();
    this.getTodayAtividades();
    this.getAtividadesAtrasadas();
    this.getAtividadesFuturas();
    this.getProjetosAtivos();
  }
}
</script>